import request from '@/utils/request'

export function getSystemInfo() {
  return request({
    url: '/system/info',
    method: 'post'
  })
}

export function getNoticeList(type = 'SYSTEM') {
  return request({
    url: `/user/message/list/${type}`,
    method: 'get'
  })
}
export function getNoticeInfo(id) {
  return request({ url: `/user/message/${id}/info`, method: 'get' })
}

export function getNoticeNoReadNum() {
  return request({ url: `/user/message/noReadNum`, method: 'get' })
}
